import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import StudyProgramsActions, { StudyProgramsRedux, StudyProgramsTypes } from '../Redux/StudyProgramsRedux'

const StudyProgramsCRUDObservable = createCRUDObservable({
  mainRedux: StudyProgramsRedux,
  reduxPath: 'study_programs',
})
export const StudyProgramsObservers = Object.assign({}, StudyProgramsCRUDObservable.observers, {})
export const StudyProgramsEpic = combineEpics(
  StudyProgramsCRUDObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/StudyProgramsObservable.js